import React from 'react'
import configs from '../../contentConfig';
import { Link } from 'react-router-dom';
import { trackWidgetClick } from '../../utils/FunctionsForGa';

const content = configs?.["explore"]?.["searchOnMap"]?.content || {};

const SearchOnMap = () => {
const selectedFilter = JSON.parse(localStorage.getItem("selectedFilter"))
  const handleGA = ()=>{
      if(process.env.REACT_APP_GA_ENABLED==="true"){
        const ga_payload = {
          action:selectedFilter,
          type: "Search on a Map Widget",
          widget_name:"Search on a Map",
          isFavorite: false,
        }
    
        trackWidgetClick(ga_payload)
      }
     }
  return (
    <Link to={"/?path=map"} className='w-full' onClick={handleGA}>
      <div className="search-on-map">
        <div className="search-on-map-image">
          <div alt="search on map image" className="search-on-map-image-element" />
        </div>
        <div className="search-on-map-text">
          <h2 className="search-on-map-title">{content.title || "Search on a Map"}</h2>
          <p className="search-on-map-subtitle">{content.subTitle || "Get a bird's eye view"}</p>
        </div>
      </div>
    </Link>
  )
}

export default SearchOnMap
